export const common = {
  nav: {
    home: 'Inicio',
    about: 'Acerca de',
    structure: 'Estructura',
    contact: 'Contacto'
  },
  footer: {
    legal: 'Legal',
    imprint: 'Aviso Legal',
    privacy: 'Política de Privacidad',
    cookieSettings: 'Configuración de Cookies',
    contact: 'Contacto',
    registerCourt: 'Registro Mercantil',
    copyright: '© 2026 DR Group GmbH. Todos los derechos reservados.'
  },
  cookies: {
    banner: {
      title: 'Configuración de Cookies',
      description: 'Utilizamos cookies para mejorar su experiencia de navegación. Puede aceptar todas las cookies, rechazarlas o personalizar su configuración.',
      acceptAll: 'Aceptar Todas',
      rejectAll: 'Rechazar Todas',
      settings: 'Configuración'
    },
    settings: {
      title: 'Configuración de Cookies',
      description: 'Gestione sus preferencias de cookies. Puede cambiar su configuración en cualquier momento.',
      savePreferences: 'Guardar Preferencias',
      categories: {
        necessary: {
          title: 'Cookies Necesarias',
          description: 'Estas cookies son esenciales para el funcionamiento del sitio web y no se pueden desactivar.'
        },
        functional: {
          title: 'Cookies Funcionales',
          description: 'Estas cookies permiten funcionalidades mejoradas y personalización.'
        },
        analytics: {
          title: 'Cookies de Análisis',
          description: 'Estas cookies nos ayudan a entender cómo los visitantes interactúan con nuestro sitio web.'
        },
        marketing: {
          title: 'Cookies de Marketing',
          description: 'Estas cookies se utilizan para rastrear visitantes en sitios web para mostrar anuncios relevantes.'
        }
      }
    }
  }
};
